<script setup>
import TitleTwo from '@/components/title-des/titleTwo.vue'
const mapData = ref([
  {
    id: '01',
    tip: '云',
    title: '云南运营中心',
  },
  {
    id: '02',
    tip: '贵',
    title: '贵州运营中心',
  },
  {
    id: '03',
    tip: '新',
    title: '新疆运营中心',
  },
])
</script>

<template>
  <div class="industryPart w-full">
    <div class="w-full">
      <div>
        <TitleTwo
          title="国内运营中心"
          top="24px"
          bottom="20px"
          sub-title="搭建产业合作桥梁，助力企业全球化发展"
        />
      </div>
      <div
        class="w-full flex justify-center gap-2"
      >
        <div
          v-for="item in mapData"
          :key="item.id"
          class="w-[210px] h-[180px] itemBg flex flex-col justify-center items-center"
        >
          <div class="item">
            {{ item.tip }}
          </div>
          <div class="text-[#333] text-[24px] text-center mt-2">
            {{ item.title }}
          </div>
        </div>
      </div>
      <img src="https://static.idicc.cn/cdn/official/H5/about_bottom.png" alt="" class="w-full">
    </div>
  </div>
</template>

<style lang="less" scoped>
.industryPart {
  margin-top: 10px;
  padding-top: 32px;
}
.itemBg{
    background: center / contain no-repeat
      url("https://static.idicc.cn/cdn/official/H5/about_run_bg.png");
    background-size: 100% 100%;
}
.item {
   width: 80px;
    height: 80px;
    background: linear-gradient( 180deg, #6BF3FF 0%, #1741CD 100%);
  font-weight: 500;
  font-size: 28px;
  color: #FFFFFF;
  line-height: 80px;
  text-align: center;
  border-radius: 40px;
}
</style>
